export const PAGE_ACTION_IDS = {
  MOVE_SUBCATEGORY: 'moveSubcategory',
  REMIX_CONTENT: 'remixContent',
  UPDATE_DOMAIN: 'updateDomain',
  VIEW_DETAILS: 'viewDetails',
  DELETE_PERSONALIZED_CONTENT: 'deletePersonalizedContent',
  CREATE_PERSONALIZATION_VARIANT_MANUAL: 'createPersonalizationVariantManual',
  CREATE_PERSONALIZATION_VARIANT_AI: 'createPersonalizationVariantAI'
};